function NumberOnly(el_input) {
	el_input.addEventListener('keypress', function (e) {
		let key = e.keyCode;
		if (key >= "0".charCodeAt(0) && key <= "9".charCodeAt(0)) {
			return key;
		}
		e.preventDefault();
	});
}
